import { DynamicDocumentItemType, DynamicDocumentItem, DynamicDocumentItemData } from '@/types';

type Validator = (data: DynamicDocumentItemData) => boolean | string | string[];

function isValidMultipleChoice(data: DynamicDocumentItemData): boolean {
  const value = data.value as string | string[];

  return !!value?.length;
}

function isValidImage(data: DynamicDocumentItemData): boolean {
  const value = data.value as string[];
  return !!value && value.length > 0;
}

function isValidBool(data: DynamicDocumentItemData): boolean {
  return typeof data.value === 'boolean';
}

function isValidNumber(data: DynamicDocumentItemData): boolean {
  return typeof data.value === 'number' && !Number.isNaN(data.value as number);
}

function isValidText(data: DynamicDocumentItemData): boolean {
  const value = data.value as string;
  return !!value && value.length > 0;
}

function isValidSignature(data: DynamicDocumentItemData): boolean {
  const value = data.value as string[];
  return !!value && value.length > 0 && !!value[0] && !!value[1];
}

/** At least one serienummer actually filled in — the manager seeds an empty placeholder row. */
function isValidSerial(data: DynamicDocumentItemData): boolean {
  const value = data.value as { serialNumber?: string }[];

  return Array.isArray(value) && value.some(entry => !!entry?.serialNumber?.trim());
}

function noop(data: DynamicDocumentItemData): boolean {
  return true;
}

const validators: Record<DynamicDocumentItemType, Validator> = {
  HIDDEN: () => false,
  WARNING: noop,
  MULTIPLE_CHOICE: isValidMultipleChoice,
  IMAGE: isValidImage,
  BOOL: isValidBool,
  TEXT: isValidText,
  SIGNATURE: isValidSignature,
  DATE: noop,
  VALUE: noop,
  HEADER: noop,
  NUMBER: isValidNumber,
  'HIGH-LOW': noop,
  EMAIL: noop,
  CUSTOM: noop,
  SERIAL: isValidSerial,
};

export default function isValidItem(
  item: DynamicDocumentItem,
  data?: DynamicDocumentItemData,
): boolean | string | string[] {
  if (!data) return false;

  const validator = validators[item.type];

  return validator ? validator(data) : true;
}
